import axios from 'axios';
import { useState, createContext, useContext, useEffect } from 'react';

export const ConfigContext = createContext(null);
export const useConfig = () => { return useContext(ConfigContext); };

const comboArray = ['staticJobArea', 'jobArea', 'country', 'county', 'settlement', 'office', 'typesOfRoad', 'specialization', 'language', 'skill', 'countryCode', 'serviceProviderNumber', 'mekiSettlement', 'mekiCounty', 'mekiOffice'];

export default function ConfigProvider(props) {
	const [comboData, setComboData] = useState(null);
	const [prettyUrlMap, setPrettyUrlMap] = useState(null);

	const menuItems = [
		{ 'label': 'diákmunkák', 'path': '/diakmunka' },
		{ 'label': 'kapcsolat', 'path': '/kapcsolat' },
		{ 'label': 'jó tudni', 'path': '/jo-tudni' },
		{ 'label': 'blog', 'path': '/blog' },
		{ 'label': 'shop', 'path': '/shop' },
		{ 'label': 'digitális ügyintézés', 'path': '/digitalis-ugyintezes' },
		{ 'label': 'regisztráció', 'path': '/regisztracio', 'className': 'text-lime-600 uppercase font-bold' },
		{ 'label': 'belépés', 'path': '/bejelentkezes', 'className': 'text-sky-400 uppercase font-bold' },
	];

	useEffect(() => {
		getPrettyUrlMap();
		getComboData();
	}, []);

	const getComboData = () => {
		const url = global.backingsEndpoint + 'employeeUserControl/getComboData';
		const body = { 'comboNames': { 'types': comboArray } };
		axios.post(url, body).then(function (response) { if (response.data) { setComboData(response.data); } }).catch(function (error) { console.log(error); });
	};

	const getPrettyUrlMap = () => {
		const url = global.backingsEndpoint + 'employeeUserControl/getPrettyUrlMap';
		axios.post(url, {}).then(function (response) { if (response.data) { setPrettyUrlMap(response.data); } }).catch(function (error) { console.log(error); });
	};

	const getCombo = (key) => {
		return comboData[key];
	};

	const value = {
		menuItems,
		comboData,
		getCombo,
		prettyUrlMap,
	};

	return (
		<ConfigContext.Provider value={value}>
			{props.children}
		</ConfigContext.Provider>
	);
}
